<template>
  <div>
    <autocomplete
      v-if="!selectedCleaner"
      :label="label ? label : $t('general.manager')"
      :source="apiUrl(
        '/managers?active=1'
        +(region?('&region[]='+region):''))
        +'&search_contact='"
      :results-formatter="resultsFormatter"
      results-display="name"
      :request-headers="requestHeaders"
      @selected="onSelect"
    >
      <template v-slot:resultsList="slotProps">
        <v-list two-line dense v-model="slotProps.display">
          <template v-for="(cleaner, key) in slotProps.results">
            <v-divider
              :key="key + '_divider'"
            />
            <v-list-item
              :key="key"
              class="autocomplete__results__item"
              :class="{'autocomplete__selected' : slotProps.isSelected(key) }"
              @click.prevent="slotProps.select(cleaner)"
              style="min-height: 0; user-select: initial;"
            >
              <v-list-item-content class="py-0">
                <v-list-item-title
                  class="mb-0 d-flex"
                >
                  {{cleaner.name}}
                  <a :href="'tel:'+cleaner.phone"
                     class="ml-auto"
                  >
                    {{cleaner.phone}}
                  </a>
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{cleaner.note}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </template>
    </autocomplete>
    <v-card
      v-else
      :style="{
        opacity: (!selectedCleaner.active)?0.5:1,
        backgroundColor: bgColor?bgColor:'white',
      }"
    >
      <v-list-item
        style="user-select: initial;"
      >
        <v-list-item-content>
          <div
            v-if="selectedCleaner.active === 0"
          >
            {{lang($store, 'sap/listings.global.not_active')}}
          </div>
          <v-list-item-title class="headline mb-1">
            <span style="font-size: 16px;">
              {{selectedCleaner.name}}
            </span>
            <div class="d-block d-sm-inline-block ml-0 ml-sm-2">
              <phone-chip
                :small="true"
                :phone="selectedCleaner.phone"
              />
            </div>
          </v-list-item-title>
          <v-list-item-subtitle>
            {{selectedCleaner.note}}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-btn icon absolute top right
             style="top: 5px; right: 5px;"
             @click="$emit('select', null);"
      >
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </v-card>
    <v-alert
      v-if="errorMessages"
      type="error">
      {{errorMessages}}
    </v-alert>
  </div>
</template>

<script>
/* utild */
import autocompleteMixin from '../../mixins/autocompleteMixin';
/* Components */
import Autocomplete from './Autocomplete.vue';
import PhoneChip from '../minialerts/PhoneChip.vue';

export default {
  name: 'ManagerSelector',
  mixins: [autocompleteMixin],
  props: {
    region: {
      type: String,
      default: '',
    },
    selectedCleaner: {
      type: Object,
      default: null,
    },
    errorMessages: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    bgColor: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      managers: [],
    };
  },
  components: {
    Autocomplete,
    PhoneChip,
  },
  methods: {
    resultsFormatter(response) {
      return response.data.managers.data;
    },
    onSelect({/* value, display, */ selectedObject }) {
      // console.warn(value);
      // console.warn(display);
      // console.warn(selectedObject);
      this.$emit('select', selectedObject);
    },
  },
};
</script>

<style scoped>

</style>
